




















































import { defineComponent } from '@vue/composition-api';
import AccountsReceivableParams from '@/domain/models/preNegotiations/accountsReceivable/AccountsReceivableParams';

export default defineComponent({
  name: 'PreNegotiationAccountParams',
  props: {
    loading: {
      type: Boolean,
      require: true,
    },
    accountParams: {
      type: Object as () => AccountsReceivableParams,
      required: false,
      default: false,
    },
  },
});
